import { OpenAPI as AdminOpenAPI } from '@generated/admin/core/OpenAPI';
import { OpenAPI } from '@generated/front/core/OpenAPI';
import { tokenState } from './ridge';

const getToken = async () => {
  return tokenState.get() || '';
};

OpenAPI.TOKEN = getToken;
AdminOpenAPI.TOKEN = getToken;
